//Post Office
export const FETCH_POSTOFFICE_REQUEST = 'FETCH_POSTOFFICE_REQUEST';
export const FETCH_POSTOFFICE_SUCCESS = 'FETCH_POSTOFFICE_SUCCESS';
export const FETCH_POSTOFFICE_FAILURE = 'FETCH_POSTOFFICE_FAILURE';
export const FETCH_NOTIFICATION_REQUEST = 'FETCH_NOTIFICATION_REQUEST';
export const FETCH_NOTIFICATION_SUCCESS = 'FETCH_NOTIFICATION_SUCCESS';
export const FETCH_NOTIFICATION_FAILURE = 'FETCH_NOTIFICATION_FAILURE';
